import { AppContext } from './../../AppContext';
import React, {useContext, useEffect } from 'react';
import { signinRedirectCallback } from '../../services/authService';

export const Callback: React.FC = (): React.ReactElement => {
    const { userManager } = useContext(AppContext);
    useEffect(() => {
        signinRedirectCallback(userManager);
    });
    return <></>;
};